export default "__VITE_ASSET__DUBv6Nbz__"